<!--
    描述：材价清单 --- 首页
    时间：2020-08-31
    Created by ws
-->
<!--
    描述：清单检查 tab 页
    时间：2020-08-19
    Created by ws
-->
<template>
	<w-split v-model="splitV"
			 class="material-main">
		<!-- 左侧结构树 -->
		<left-structure slot="left"
						:editable="false"
						:showCheckbox="true"
						ref="leftTree"
						@rowClick="leftRowClick"
						@onCheck="checkChange"></left-structure>

		<!-- 右侧表格 -->
		<div class="w-strucutre-layout"
			 slot="right">
			<div class="w-strucutre-header">
<!--				<span class="title pdl10 text-overflow">
					<el-tooltip class="item"
								effect="dark"
								:content="curName"
								placement="bottom-start">
						<span>{{ curName }}</span>
					</el-tooltip>
				</span>-->

				<div class="btnGroups">
					<el-button size="small"
							   icon="el-icon-sort"
							   class="ml10"
							   type=""
							   @click="doSort">分类排序
					</el-button>
					<el-button size="small" icon="el-icon-sort" class="ml10" :type="showAllData ? 'danger' : 'success'" @click="changeTableType">{{ showAllData ? "异常清单" : "全部清单" }}
                    </el-button>
					<el-button size="small"
							   icon="el-icon-refresh"
							   class="ml10"
							   type="warning"
							   @click="doRefresh">重置
					</el-button>
					<el-button size="small"
							   icon="el-icon-menu"
							   class="ml10"
							   type="primary"
							   @click="doFilter">列过滤
					</el-button>
					<el-button plain
							   size="small"
							   type="primary"
							   icon="el-icon-download"
							   v-if="roleBtns.includes('material-Excel')|| curSource === '1'"
							   @click="doExport('excel')">导出Excel
					</el-button>
					<el-button size="small"
							   icon="el-icon-upload"
							    v-if="roleBtns.includes('material-Html')|| curSource === '1'"
							   @click="doExport('html')">导出Html
					</el-button>
				</div>
			</div>
			<div class="w-structure-content"
				 v-loading="sheetLoading">
				<material-table ref="materialTable"
								:searchForm="queryParams"></material-table>
			</div>
		</div>
	</w-split>
</template>

<script>
// component
import leftStructure from '@/views/project-management/project-info/components/left_structure'
// import materialTable from './material_table'
import materialTable from './material_table_new'

// js
import { mapState } from 'vuex'
import { getCodeList, getMaterialNames } from '@/api/modules/analysisInventory'
import { exportExcel, dateFormat } from '@/utils/tools'

export default {
	components: {
		leftStructure,
		materialTable
	},
	data() {
		return {
			splitV: 0.3,
			sheetLoading: false, // 列表等待状态
			resData: {}, // 新动态返回的数据
			tableData: [],
			// 弹窗对象
			dialogObj: {
				title: '添加对比',
				visible: false,
				width: '90%',
				type: 'filter',
				exportExcel: false
			},
			curName: '', // 当前点击的 结构树层级名称
			btnLoading: false,
			// 对比筛选数据
			compareFilter: [
				{
					label: '计量单位',
					key: 'unit'
				},
				{
					label: '工程量',
					key: 'quantity'
				},
				{
					label: '单价',
					key: 'rateCost'
				},
				{
					label: '合价',
					key: 'addup'
				},
				{
					label: '备注',
					key: 'remark'
				},
				{
					label: '规格',
					key: 'specification'
				}
			],
			compareArr1: ['unit', 'quantity', 'rateCost', 'addup'], // 最终筛选的 对比数组1
			// 导出、查询 参数对象
			queryParams: {
				projectId: '', // 项目ID
				treeId: [], // 单位工程ID 数组
				phase: '', // 造价阶段
				type: 1, // 是六算或者 每一期进度款 （1 / 2）
				code: [], // 编码
				projectFeatures: '', // 清单特征
				projectName: '', // 清单名称
				unit: '', // 计量单位
				userName: 'xxx',
				unitQuery: 0
			},
			codeList: [], // 清单编码数组
			codeArr: [], // 所选的清单编码 数组
			checkAll1: false, // 全选按钮
			// 是否展示全部清单、异常清单
            showAllData: true
		}
	},
	created() {
		// this.$nextTick(() => {
		// 	this.getCodeTypeList()
		// })
	},
	methods: {
		// 左侧项目结构树点击事件
		leftRowClick(row) {
			// 项目名称 以及  当前层级名称
			let _pname = this.projectName
			let _name = row.sname

			// 第一级
			if (row.levelType === 0) {
				this.curName = _name
			} else if (row.levelType === 1) {
				this.curName = _pname + ' | ' + _name
			} else {
				let _dname = this.$refs.leftTree.tableData[0].children.find(
					x => x.id === row.pid
				).sname
				this.curName = _pname + ' | ' + _dname + ' | ' + _name
			}
		},

		// 复选框选择事件
		checkChange(arr) {
			if (this.$refs.materialTable) {
				this.queryParams.treeId = arr
				let params = this.setParams()
				// this.$refs.materialTable.getTableData(params)
				// new
				this.loadDetailTable(params)

				// 获取名称和 编码数组
				this.getCodeTypeList(params)
			}
		},

		// 获取编码分类数组
		getCodeTypeList(params) {
			getMaterialNames(params)
				.then(res => {
					if (this.$refs.materialTable) {
						// 材料名称过滤数组
						this.$refs.materialTable.filterObj.nameList =
							res.data.fileResNames
						// 单位数组
						this.$refs.materialTable.filterObj.unitList =
							res.data.fileResUnits
						// 规格型号数组
						this.$refs.materialTable.filterObj.specifications =
								res.data.specifications
					}
				})
				.catch(err => {})
		},

		// 加载表格
        loadDetailTable(params) {
            if (this.$refs.materialTable) {
                // 请求参数
            	this.$refs.materialTable.queryParams = this.$utils.clone(params, true)

            	this.$refs.materialTable.loadData()
            }
        },

		// 点击查询
		doSearch() {
			if (this.queryParams.treeId.length === 0) {
				this.$message.info('请先从左侧选择 单位工程!')
				return
			}

			let params = this.setParams()
			// this.$refs.materialTable.getTableData(params)
			// new
			this.loadDetailTable(params)
		},

		// 分类排序
		doSort() {
			let params = this.setParams()
			params.unitQuery = 1

			// 先清除排序
			this.$refs.materialTable.clearSort()

			// 打开排序弹窗
            this.$refs.materialTable.openSort()

			// this.$refs.materialTable.getTableData(params)
			// new
			// this.loadDetailTable(params)
		},

		// 切换表格展示（全部清单、异常清单）
        changeTableType() {
            this.showAllData = !this.showAllData;
            this.$refs.materialTable ? this.$refs.materialTable.changeData(this.showAllData) : ''
        },

		// 点击重置
		onReset() {
			this.codeArr = []
			this.queryParams.projectName = ''
			this.queryParams.code = []
			this.queryParams.unit = ''
			this.queryParams.projectFeatures = ''
			this.queryParams.unitQuery = 0

			// 清除过滤器
			if (this.$refs.materialTable) {
				// this.$refs.materialTable.clearFilter()
				// this.$refs.materialTable.clearSort()
				this.$refs.materialTable.clearAll()
			}
		},

		// 点加刷新
		doRefresh(val) {
			// 重置查询条件
			this.onReset()

			// 清除过滤器
			if (this.$refs.materialTable) {
				this.$refs.materialTable.clearFilter()
			}

			// 执行查询
			this.doSearch()
		},


		// 请求传值参数设置
		setParams() {
			// 项目ID
			this.queryParams.projectId = this.curProjectId
			// 造价阶段
			this.queryParams.phase = this.$refs.materialTable.priceType1
			this.queryParams.type = this.$refs.materialTable.getPhaseObj.name1

			// 排序字段
            let _sort = this.$refs.materialTable.sortArr.filter(x => x.visible)
            this.queryParams.sortField = _sort.map(x => x.key) || []
			// 编码
			this.queryParams.code = this.codeArr.map(x => x[x.length - 1])
			this.queryParams.userName = this.userName
			return this.queryParams
		},

		// 点击列过滤按钮
		doFilter() {
			// this.dialogObj.title = '列过滤'
			// this.dialogObj.type = 'filter'
			// this.dialogObj.visible = true
			if (this.$refs.materialTable) {
                this.$refs.materialTable.openFilter()
            }
		},

		// 点击导出 （0 是excel, 1 是html）
		doExport(type) {
			if (
				this.$refs.materialTable &&
				this.$refs.materialTable.getListData().length === 0
			) {
				this.$message.info('暂时没有要导出的数据！')
				return
			}
			let saveName = '材价检查数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
			let params = this.setParams()
			params.projectName = this.projectName
			params.exportType = type
			params.saveName = saveName
			params.totalSum = this.$refs.materialTable.totalSum
			params.list = this.$refs.materialTable.getListData() || []
			exportExcel('fileResource/checFileResourceExport', params, saveName)
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		// 项目名称
		projectName() {
			return this.$route.query.projectName
		},

		// 项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),

		// 用户名称
		...mapState('user', {
			userName: state => state.userInfo.sname
		})
	},
	watch: {
		// 列过滤 是否 全选
		compareArr1(arr) {
			if (arr.length === this.compareFilter.length) {
				this.checkAll1 = true
			} else {
				this.checkAll1 = false
			}
		}
	}
}
</script>

<style scoped lang="less">
.material-main {
	.check-row {
		margin-bottom: 7px;
		// background-color: #a3e3ff;
		height: 35px;
		line-height: 35px;
		font-weight: 700;
		color: #333;
		.check-name {
			border-right: 3px solid #1d7f8a;
		}

		.check-content {
			text-align: left;
			padding-left: 15px;
		}
	}

	.check-row:nth-of-type(2) {
		background-color: #f5f5ad;
	}

	.check-row:nth-of-type(3) {
		background-color: #ffe4c4;
	}

	.check-row:nth-of-type(4) {
		background-color: #7fffd4;
	}

	.range-header {
		text-align: left;
		padding-left: 10px;
		height: 35px;
		line-height: 35px;
	}

	.range-content {
		padding: 10px;
		.range-row {
			display: flex;
			height: 40px;
			line-height: 40px;
			margin-bottom: 10px;
		}
		.range-row-name {
			display: flex;
			align-items: center;
			width: 100px;
		}
		.range-row-input {
			flex: 1;
			text-align: left;
		}
	}
}
</style>


